import validate from 'lib/utils/validationRules';
import Attachment from 'lib/project/classes/Attachment';

class ArrangementStruct {
  constructor(data = {}) {
    this.id = data?.id || null;
    this.count = data.count ? String(data.count) : '';
    this.countBundle = data.countBundle ? String(data.countBundle) : '1';
    this.countPerPayment = data.countPerPayment ? String(data.countPerPayment) : '';
    this.template = new Attachment(data?.template);
    this.isCanCountBundle = data.countBundle ? false : true;
  }

  getData() {
    return {
      id: this.id,
      count: this.getNormalizeCount() || null,
      countBundle: this.isCanCountBundle ? null : Number(this.countBundle) || 1,
      countPerPayment: this.isCanCountBundle ? Number(this.countPerPayment) || null : null,
      template: this.template.getData(),
    };
  }

  getDataBySingleBill() {
    return {
      ...this.getData(),
      count: null,
      countBundle: Number(this.countBundle) || 1,
      countPerPayment: null,
    };
  }

  getNormalizeCount() {
    if (validate.isNull(this.count)) {
      return 0;
    }

    return Number(this.count.replace(/\s/g, ''));
  }

  getMaxCountPerPayment() {
    const count = this.getNormalizeCount();

    if (count > 0 && count <= 100) {
      return count;
    }

    return 100;
  }
}

export default ArrangementStruct;
